export const generateFormData = <T extends Record<string, Blob | string>>(obj: T): FormData => {
  const formData = new FormData();

  for (const key in obj) {
    formData.append(key, obj[key]);
  }
  return formData;
};
